module.exports = __webpack_public_path__ + "static/img/P3_gray.6b56292.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medusa/P3_gray.png
// module id = 31Lo
// module chunks = 0